module.exports = __webpack_public_path__ + "static/media/email.6d606132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.svg
// module id = 1029
// module chunks = 0